import PosSettings from './modules/PosSettings';
import PosDashboard from './modules/Dashboard';

const posStore = {
   PosSettings,
   PosDashboard,
};

export default posStore;
